import { useLexicalEditable } from '@lexical/react/useLexicalEditable'
import { createStyles } from 'antd-style'

import { ColorCursorProps } from './interface'

const useStyles = createStyles(() => ({
  cursor: {
    position: 'absolute',
    bottom: 2,
    left: 6,
    right: 6,
    height: 5,
    border: `1px solid #e2e6ed`
  }
}))

export const ColorCursor = ({ color }: ColorCursorProps) => {
  const editable = useLexicalEditable()

  const { styles } = useStyles()

  return (
    <div
      className={styles.cursor}
      style={{
        opacity: editable ? 1 : 0.5,
        backgroundColor: color
      }}
    />
  )
}
